"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arabic = void 0;
var types_1 = require("../types");
exports.arabic = {
    code: types_1.LocaleCode.Arabic,
    facebook: 'ar_AR',
    label: 'عربى',
    loadingText: 'جار التحميل...',
    dir: 'rtl',
    translations: {
        ar: 'العربية',
        de: 'الألمانية',
        en: 'الإنجليزية',
        es: 'الإسبانية',
        fr: 'الفرنسية',
        id: 'الإندونيسية',
        it: 'الإبطالية',
        ja: 'اليابانية',
        ko: 'الكورية',
        lo: 'اللاوسية',
        ms: 'الملايو',
        pt: 'البرتغالية',
        ru: 'الروسية',
        th: 'التايلاندية',
        tl: 'الفلبينية',
        tr: 'التركية',
        vi: 'الفيتنامية',
        'zh-CN': 'الصينية (المبسيطة)',
        'zh-TW': 'الصينية (التقليدية)'
    }
};
